import styled from '@emotion/styled'
import { EmployeeDetailsQuery_employee } from '../../graphql/__generated__/EmployeeDetailsQuery'
import { CompaniesList } from './components/CompaniesList'

interface CompanyContentProps {
  employee: EmployeeDetailsQuery_employee
}

export const CompaniesTab = ({ employee }: CompanyContentProps) => {
  return (
    <Base>
      <CompaniesList teamCompanies={employee.teamCompanies} />
    </Base>
  )
}

const Base = styled('div')`
  display: flex;
  flex-direction: column;
  min-height: 175px;
`
